module.exports = __webpack_public_path__ + "fonts/font.f696730.woff2";